/**
 * The rail's step ids, shared by the model that builds the rail and the
 * surfaces that record observations against it.
 *
 * These strings are PERSISTED — they're the `itemKey` of a checklist row, and
 * the `targetKey` a History visit shares with one — so they may only be built
 * from durable ids, and only here. A call site that hand-writes
 * `` `rec:${id}:notes` `` is one rename away from silently recording a mark
 * nothing reads.
 */
export const todoStepIds = {
  recommender: (recommenderId: string) => `rec:${recommenderId}`,
  recommenderNotes: (recommenderId: string) => `rec:${recommenderId}:notes`,
  recommenderProfile: (recommenderId: string) => `rec:${recommenderId}:profile`,
  recommenderScore: (recommenderId: string) => `rec:${recommenderId}:score`,
  video: (videoId: string) => `video:${videoId}`,
  /** A track node, holding that track's overview and its meeting highlights. */
  track: (track: string) => `track:${track}`,
  scoring: "scoring",
  evaluations: "evaluations",
} as const;
